import React from "react";

import { useLocation, useNavigate } from "react-router-dom";

import { Typography } from "clearsense-ui/components";
import { MenuBar as CSMenuBar } from "clearsense-ui/layouts";

import { MENUBAR_SECTIONS } from "./constants";

const MenuBar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const currentPath = pathname.substring(pathname.lastIndexOf("/") + 1);

  return (
    <CSMenuBar showMenu={true} className="dark:bg-gray-800">
      <CSMenuBar.Block
        className="font-bold -ml-2 cs-ui-menubar__title-block"
        active={currentPath === "summary"}
        onClick={() => navigate("summary")}
      >
        <Typography style="h5" type="bold">
          SUMMARY
        </Typography>
      </CSMenuBar.Block>
      {MENUBAR_SECTIONS.map(({ label, blocks }) => (
        <React.Fragment key={label}>
          <CSMenuBar.SubTitle>
            <Typography
              style="h5"
              className="uppercase cursor-pointer"
              type="bold"
              onClick={() => navigate(blocks[0].path)}
            >
              {label}
            </Typography>
          </CSMenuBar.SubTitle>
          {blocks.map(({ label, path }) => (
            <CSMenuBar.Block
              key={path}
              label={label}
              active={currentPath === path}
              onClick={() => navigate(path)}
            />
          ))}
        </React.Fragment>
      ))}
    </CSMenuBar>
  );
};

export default MenuBar;
